export default __webpack_public_path__ + "static/media/exclusive1.28e2156e.png";